import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export type GetDeviceNameAction = ActionMessage<'getDeviceName', never, string>;

export const getDeviceName = invokeAction('appAction', 'getDeviceName');
